import { useApi } from 'services';

export const useGetOperations = () => useApi(`v2/operation`, 'GET', {}, {});

export const useGetOperationsList = () => useApi(`v2/operation/list`, 'GET', {}, {});

export const useGetOperationsAsync = () => useApi(`v2/operation`, 'GET', {}, {}, true);

export const useGetOperation = (idOperation) => useApi(`v2/operation/${idOperation}`, 'GET', {}, {});

export const useGetOperationAsync = (idOperation) => useApi(`v2/operation/${idOperation}`, 'GET', {}, {}, true);

export const useSaveOperations = () => useApi(`v2/operation`, 'POST', {}, {});

export const useSaveOperationsAsync = () => useApi(`v2/operation`, 'POST', {}, {}, true);

export const useUpdateOperations = (idOperation) => useApi(`v2/operation/${idOperation}`, 'PUT', {}, {});

export const useUpdateOperationSync = (idOperation) => useApi(`v2/operation/${idOperation}`, 'PUT', {}, {}, true);

export const useGetOperationNavigation = (idOperation) => useApi(`v2/operation/${idOperation}/navigation`, 'GET', {}, {});

export const useCreateEndorsement = (idOperation) => useApi(`v2/operation/${idOperation}/endorsement`, 'POST', {}, {});

export const useCreateRenewal = (idOperation) => useApi(`v2/operation/${idOperation}/renewal`, 'POST', {}, {});

export const useGetRenewalsList = () => useApi(`v2/operation/renewals`, 'GET', {}, {});

export const useResetOperationState = (idOperation) => useApi(`v2/operation/${idOperation}/reset-state`, 'POST', {}, {}, true);

export const useLostOperation = (idOperation) => useApi(`v2/operation/${idOperation}/lost`, 'PUT', {}, {});

export const useGetCreditAnalysisList = () => useApi(`v2/operation/credit-analysis/list`, 'GET', {}, {});

export const useGetCreditAnalysisAsyncList = () => useApi(`v2/operation/credit-analysis/list`, 'GET', {}, {}, true);

export const useGetQuoteList = () => useApi(`/quote/list/v2`, 'GET', {}, {});